import {Dimensions} from 'react-native';

const {width, height} = Dimensions.get('screen');

export function calculateDistance(lat1, lon1, lat2, lon2, unit) {
  // logForCrashlytics('calculateDistance fired in helpers.js')
  if (
    lat1 != null &&
    lon1 != null &&
    lat2 != null &&
    lon2 != null &&
    unit != null
  ) {
    const radlat1 = (Math?.PI * lat1) / 180;
    const radlat2 = (Math?.PI * lat2) / 180;
    const theta = lon1 - lon2;
    const radtheta = (Math?.PI * theta) / 180;
    let dist =
      Math?.sin(radlat1) * Math?.sin(radlat2) +
      Math?.cos(radlat1) * Math?.cos(radlat2) * Math?.cos(radtheta);
    dist = Math?.acos(dist);
    dist = (dist * 180) / Math?.PI;
    dist = dist * 60 * 1.1515;
    if (unit == 'K') {
      dist = dist * 1.609344;
    }
    if (unit == 'MILES') {
      // dist = dist;
    }
    if (unit == 'N') {
      dist = dist * 0.8684;
    }
    if (unit == 'METERS') {
      dist = dist * 1.609344 * 1000;
    }
    if (unit == 'FEET') {
      dist = dist * 1.609344 * 5280;
    }
    return dist;
  } else {
    return -1;
  }
}

export function orderLocationListByDistanceAway(
  list = [],
  latitude,
  longitude,
) {
  const newLocalLocationsList = list;
  if (!latitude) {
    return newLocalLocationsList;
  }
  let newListWithDistance = [];
  newLocalLocationsList?.map?.((location) => {
    let distanceAway = undefined;
    if (latitude && longitude) {
      distanceAway = calculateDistance(
        location.lat,
        location.long,
        latitude,
        longitude,
        'MILES',
      );
      distanceAway =
        distanceAway > 10
          ? Math.round(distanceAway)
          : Math.round(distanceAway / 10) * 10;
      // Alert.alert(JSON.stringify(location));
      // Alert.alert(distanceAway + '');
    }
    newListWithDistance.push({
      ...location,
      name: location.title,
      distanceAway,
    });
  });
  newListWithDistance = newListWithDistance.sort((locA, locB) => {
    return (locA?.distanceAway || 0) - (locB?.distanceAway || 0);
  });
  return newListWithDistance;
}

export function roundLatLong(lat = 0, long = 0) {
  console.log('roundLatLong', {lat, long});
  const closestPoints = [
    [Math.floor(lat), Math.floor(long)],
    [Math.floor(lat), Math.ceil(long)],
    [Math.ceil(lat), Math.floor(long)],
    [Math.ceil(lat), Math.ceil(long)],
  ];
  let closestPoint = {lat: Math.round(lat), long: Math.round(long)};
  let closestDistance = 1000000000000000000000;
  closestPoints?.map?.((point) => {
    const distance = calculateDistance(point[0], point[1], lat, long, 'M');
    // console.log({distance, point});
    if (distance < closestDistance) {
      closestDistance = distance;
      closestPoint = {lat: point[0], long: point[1]};
    }
  });
  console.log({closestPoint});
  return closestPoint;
}

function calculateRegion(lat, lon, distanceMeters, closeUp) {
  const distance = distanceMeters / 2;
  const circumference = 40075;
  const oneDegreeOfLatitudeInMeters = 111.32 * 1000;
  const angularDistance = distance / circumference;

  const aspectRatio = width / (height - 200);

  const latitudeDelta = distance / oneDegreeOfLatitudeInMeters;
  const longitudeDelta =
    Math?.abs(
      Math?.atan2(
        Math?.sin(angularDistance) * Math?.cos(lat),
        Math?.cos(angularDistance) - Math?.sin(lat) * Math?.sin(lat),
      ),
    ) / aspectRatio;

  const longitudeDeltaOffset = distanceMeters > 500000 ? 20 : longitudeDelta;
  const result = {
    latitude: closeUp ? lat : lat - 0.01,
    longitude: lon,
    latitudeDelta: latitudeDelta,
    longitudeDelta: longitudeDeltaOffset,
  };

  return result;
}

export function calculateRegionFromPoints(
  lat1,
  long1,
  lat2,
  long2,
  closeUp = false,
) {
  lat1 = parseFloat(lat1);
  long1 = parseFloat(long1);
  lat2 = parseFloat(lat2);
  long2 = parseFloat(long2);

  const distance = calculateDistance(lat1, long1, lat2, long2, 'METERS');
  const scaleDistance = closeUp ? distance + 200 : distance + 1000;

  return calculateRegion(lat1, long1, scaleDistance, closeUp);
}

export function orderHuntsByProximity(hunts, region) {
  const {latitude, longitude} = region;

  if (latitude && longitude) {
    return hunts
      ?.map?.((hunt) => {
        let {lat, long} = hunt;
        let distanceAway = calculateDistance(
          latitude,
          longitude,
          parseFloat(lat),
          parseFloat(long),
          'N',
        );
        if (distanceAway >= 100) {
          distanceAway = distanceAway.toFixed(0);
        } else {
          distanceAway = distanceAway.toFixed(1);
        }
        return {
          ...hunt,
          distanceAway,
          isBarHunt: hunt.hunt_type == 'barHunt',
        };
      })
      ?.sort?.((a, b) => {
        const aRating = parseFloat(
          (a?.total_reviews > 1 ? a?.star_rating : 4) || '0',
        );
        const bRating = parseFloat(
          (b?.total_reviews > 1 ? b?.star_rating : 4) || '0',
        );
        const ratingDiff = bRating - aRating;
        return (
          a?.distanceAway -
          b?.distanceAway +
          5 * ratingDiff +
          0.5 * ((a?.hunt_type == 'barHunt') - (b?.hunt_type == 'barHunt'))
        );
      });
  }
  return hunts;
}
